<template>
  <div class="l-block__detail p-findTargetPage">
    <TitleSub level="h3">
      <span class="title">対策ページを見つける</span>
      <span class="description"
        >「自社キーワード分析」で対策ページを見つけましょう。</span
      >
    </TitleSub>

    <div class="p-findTargetPage__description">
      <img
        class="p-findTargetPage__description__image"
        src="@/assets/img/img-chara-task.svg"
        alt=""
        width="75"
      />
      <div class="p-findTargetPage__description__note">
        <span
          >「自社キーワード分析」で対策ページを見つけたら、<br />「検索順位チェックのキーワードに追加」と「タスク追加」を忘れずしましょう。</span
        >
      </div>
    </div>

    <div class="p-findTargetPage__content">
      <span class="p-findTargetPage__content__header">リライト対象</span><br />
      <span class="p-findTargetPage__content__note"
        >6~50位を獲得しているキーワードを、表示回数順に対策するのがおすすめです。</span
      ><br />
      <Button
        variant="main"
        :to="{
          name: 'siteKeywordAnalysis',
          query: {
            rankMax: 6,
            rankMin: 50
          }
        }"
        size="w416"
        fsize="f16"
        radius
      >
        「自社キーワード分析」でリライト対象を見つける
      </Button>
    </div>

    <div class="p-findTargetPage__content">
      <span class="p-findTargetPage__content__header">タイトル変更対象</span
      ><br />
      <span class="p-findTargetPage__content__note"
        >1~5位を獲得しているキーワードを、クリック率が少ない順に対策するのがおすすめです。</span
      ><br />
      <Button
        variant="main"
        :to="{
          name: 'siteKeywordAnalysis',
          query: {
            sort: 'ctr',
            order: 'asc',
            rankMax: 1,
            rankMin: 6
          }
        }"
        size="w448"
        fsize="f16"
        radius
      >
        「自社キーワード分析」でタイトル変更対象を見つける
      </Button>
    </div>
  </div>
</template>

<script>
import TitleSub from '@/components/TitleSub';
import Button from '@/components/Button';

export default {
  components: {
    TitleSub,
    Button
  }
};
</script>
